import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'prop-types';
import * as React from 'react';
import { isBoolean } from '../utils/lang.js';

var useControlledDropdown = function useControlledDropdown(props) {
  var showing = props.showing;

  var _React$useState = React.useState(!!showing),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showingState = _React$useState2[0],
      _setShowingState = _React$useState2[1];

  React.useEffect(function () {
    var nextShowingState = isBoolean(showing) ? showing : showingState;

    _setShowingState(!!nextShowingState);
  }, [showingState, showing]);
  return {
    showingState: showingState,
    setShowingState: function setShowingState(nextShowingState) {
      if (isBoolean(showing)) return;

      _setShowingState(nextShowingState);
    }
  };
};

export { useControlledDropdown };
